module.exports = __webpack_public_path__ + "files/93f2548c525f4d1831e4065fec426312.svg";